const initualState = {
  allFunds: [],
  currentFund: { fundName: null, fundPrice: null },
  fundByDate: {
    fundName: null,
    fundHistoryPrice: null,
    fundPrice: null,
    fundId: null,
    input: { from: new Date(), to: new Date() }
  }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_All_FUNDS_VALUES":
      return { ...state, allFunds: action.payload };
    case "SET_CURRENT_FUND":
      return { ...state, currentFund: action.payload };
    case "SET_FUND_BY_DATE":
      return { ...state, fundByDate: action.payload };
    default:
      return state;
  }
};
